import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import DataTable from "../../../component/element/table";
import { ColumnDef } from "@tanstack/react-table";
import { FaUser, FaUserLock } from "react-icons/fa6";
import { getCompanyBranchUsers } from "../../../services/apis/company";
import { IEmployeeProfile } from "../../../store/types/company";

type ICompanyBranchUserProps = {
  companyId: string | undefined;
};

const CompanyBranchUser: React.FC<ICompanyBranchUserProps> = ({
  companyId,
}) => {
  const dispatch = useAppDispatch();

  // Get users from Redux store
  const users = useAppSelector(({ company }) => company.companyBranchUsers);

  // Fetch users on mount or when companyId changes
  useEffect(() => {
    if (!companyId) return;

    const fetchUsers = async () => {
      await getCompanyBranchUsers(companyId, dispatch);
    };

    fetchUsers();
  }, [companyId, dispatch]);

  const columns: ColumnDef<IEmployeeProfile>[] = [
    {
      accessorKey: "name",
      header: () => <span>Name</span>,
    },
    {
      accessorKey: "user.email",
      header: () => <span>Email</span>,
    },
    {
      accessorKey: "phone",
      header: () => <span>Phone</span>,
    },
    {
      accessorKey: "user.role",
      header: () => <span>Role</span>,
      cell: ({ getValue }) => {
        const role = getValue() as string;
        return role === "1" ? (
          <FaUserLock size={20} color="red" />
        ) : (
          <FaUser size={20} color="blue" />
        );
      },
    },
    {
      accessorKey: "branch.company_address",
      header: () => <span>Branch</span>,
    },
  ];

  return <DataTable columns={columns} data={users || []} />;
};

export default CompanyBranchUser;
